import { useParams } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";
import React, { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const firebaseConfig = {
    apiKey: "AIzaSyB19bNEm_CAPMB8YFl1qdhthuO3u-anZ3M",
    authDomain: "publictv-666.firebaseapp.com",
    databaseURL: "https://publictv-666.firebaseio.com",
    projectId: "publictv-666",
    storageBucket: "publictv-666.appspot.com",
    messagingSenderId: "836055437569",
    appId: "1:836055437569:web:3af6b642650d32c3594b00",
    measurementId: "G-T6YCYHXVYB"
};

const app = initializeApp(firebaseConfig);

const database = getDatabase(app);

function Share() {

    //document.title = "AHHHHH"

    /*const {shareKey} = useParams();

    console.log(shareKey+"<-----KEYY");

   window.location.href = 'https://play.google.com/store/games?hl=es_MX';
    return null;*/
    const [channelName, setChannelName] = useState("");
    const { sharekey } = useParams();

    const url = "https://play.google.com/store/apps/details?id=com.firefly.opentv&referrer=utm_source%3Dshare%26utm_content%3D" + sharekey;

    //window.location.href = url

    //return null;


    useEffect(() => {
        const reference = ref(database, 'shares/' + sharekey);
        onValue(reference, (snapshot) => {
            const data = snapshot.child("channel").val();
            setChannelName(data)
        });
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            // Esto causa una recarga completa de la página
            window.location.replace(url); // Puedes usar una ruta interna como '/otra-pagina'
        }, 3000);

        return () => clearTimeout(timer);
    }, []); // El array de dependencias está vacío porque no usa props ni estado


    return (
        <div>
            <HelmetProvider>
                <Helmet>
                    <title>{channelName}</title>
                    <link rel="canonical" href="https://play.google.com/store/apps/details?id=com.firefly.opentv" />
                    <meta property="og:title" content={channelName} />
                    <meta property="og:url" content="https://tvenvivo.cloud/"></meta>
                    <meta property="og:description" content="Tv en vivo" />
                    <meta property="og:image" itemprop="image primaryImageOfPage" content="https://firebasestorage.googleapis.com/v0/b/publictv-666.appspot.com/o/web%2Flogo192.png?alt=media&token=edfe10da-8340-448a-b8d8-880f7290c4e0" />

                </Helmet>
                <h1>{channelName}</h1>
                <h2>Serás redirigido a la Play Store en 3 segundos...</h2>
            </HelmetProvider>

        </div>

    );
}

export default Share;